import { Network } from '@shared/types'
import { Wallet } from '@injectivelabs/wallet-base'
import { PEGGY_NETWORKS } from '@/app/data/network'
import type { Wallet as WalletType } from '@injectivelabs/wallet-base'

export const walletNetworkMapping: Record<string, string[]> = {
  [Wallet.Metamask]: PEGGY_NETWORKS,
  [Wallet.Rabby]: PEGGY_NETWORKS,
  [Wallet.BitGet]: PEGGY_NETWORKS,
  [Wallet.Rainbow]: PEGGY_NETWORKS,
  [Wallet.Ledger]: PEGGY_NETWORKS,
  [Wallet.TrezorBip32]: PEGGY_NETWORKS,
  [Wallet.OkxWallet]: PEGGY_NETWORKS,
  [Wallet.TrustWallet]: PEGGY_NETWORKS,
  [Wallet.WalletConnect]: PEGGY_NETWORKS,
  // cosmos wallets
  [Wallet.Keplr]: [
    Network.XionTestnet,
    Network.Celestia,
    Network.Evmos,
    Network.Osmosis,
    Network.Sommelier,
    Network.Axelar,
    Network.Kava,
    Network.Oraichain,
    Network.Stride,
    Network.Persistence,
    Network.Secret,
    Network.CosmosHub,
    Network.CosmosHubTestnet,
    Network.Andromeda,
    Network.Noble,
    Network.Saga,
    Network.Fetch,
    Network.Mantra,
    Network.EvmosTestnet,
    Network.Xion
  ],
  [Wallet.Leap]: [
    Network.Kava,
    Network.Osmosis,
    Network.CosmosHub,
    Network.CosmosHubTestnet,
    Network.Kujira,
    Network.Celestia,
    Network.Evmos,
    Network.Persistence,
    Network.Crescent,
    Network.Sommelier,
    Network.Stride,
    Network.Axelar,
    Network.Migaloo,
    Network.Secret,
    Network.Noble,
    Network.Saga,
    Network.Fetch,
    Network.Xion
  ]
  // [Wallet.LedgerCosmos]
}

export const hardwareWallets = [
  Wallet.Ledger,
  Wallet.TrezorBip32
] as WalletType[]
